<template>
  <div class="youtaofang">
    <topTitle title="钱湖柏庭" :list="list" :newData="newData"></topTitle>
    <p class="top_title">宁波钱湖柏庭养老投资有限公司</p>
    <p class="content">
      钱湖柏庭---择址于东钱湖国家旅游度假区，是宁波知名养老企业柏庭国际养老产业集团旗下，面向健康活力长者的会员制CCRC高端养老社区。钱湖柏庭园区占地约[120亩]， 分南、北两个区域，总建筑面积约[11万平方米]， 包括 20 栋多层健康公寓、16 栋适老中式别墅。园区自然环境优美，四面环山，山水相映成趣，各类生活、休闲、运动、文教、养生、医疗等配套一应俱全，2016年开工建设，2019年2月正式开业运营。
    </p>
    <p class="content">
      钱湖柏庭，以提高活力长者退休生活品质，实现他们"人生中最美好的时光"为服务目标，围绕"有套房、有块地、有地暖、有社团、有管家"的"五有"专业服务，通过打造养、学、游等一站式服务，为入住长者提供国际化、人性化、高质量的养老生活体验。
    </p>
    <p class="content">
       钱湖柏庭，引入"老年大学社区化运营"理念，积极发挥活力长者老有所乐，老有所学的生活理念，鼓励长者自发建立各类俱乐部社团组织20多个，并设立柏华学院，开设专业课程10多门，极大的丰富了会员的精神生活，以人为本、以学交友、以邻为亲，为长者创造一个健康生活、自由发展、身心愉悦的颐养生活。
    </p>
    <p class="content">
      钱湖柏庭，内设的7个科室的社区医院为会员提供日常的健康管理、慢病管理以及突发疾病的院前急救，并与宁波李惠利医疗中心建立了快速绿色通道，为长者的健康保驾护航。39项全方位的管家服务，覆盖了长者生活、快乐和健康的各项需求，为长者提供有温度、有趣味、有保障的专业服务。
    </p>
    <p class="content">
      在钱湖柏庭，快乐是延缓衰老最有效的良方，从深入日常的贴心照料、到精神上的美好，柏庭人让长者们可以尽情绽放更美好的百岁人生，尽享无忧的金色年华。
    </p>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          children: [
            {
              title: "2020",
              id: "1",
            },
            {
              title: "2019",
              id: "2",
            },
            {
              title: "2018",
              id: "3",
            },
          ],
        },
      ],
      newData: 0,
      list2: [
        {
          img: require("../../assets/image/fuwu/fang_1.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_2.png"),
        },
        {
          img: require("../../assets/image/fuwu/fang_3.png"),
        },
      ],
    };
  },
  methods: {},
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
  
  },
};
</script>
<style scoped="scoped">
.youtaofang {
  width: 100%;
  height: 100%;
}
.top_title{
    margin-top: 0.675rem;
    margin-bottom: 0.675rem;
    font-family: PingFang SC;
font-weight: 400;
color: #212121;
line-height: 0.525rem;

font-size: 0.45rem;
}
.content{
    text-align: left;
    text-indent: 2em;
     font-family: PingFang SC;
font-weight: 400;
color: #212121;
font-size: 0.3rem;
line-height: 0.525rem;
margin-bottom: 0.25rem;
}
</style>